import styled, { css } from 'styled-components';

export const ShadowSection = styled.div`
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  margin: 16px 0;
  padding: ${(props) => props.padding};

  @media (max-width: 720px) {
    box-shadow: ${(props) =>
      props.newUserbought ? 'none' : '#00000029 0px 1px 2px 0'};
    border: none;
    border-radius: 0;
    padding: ${(props) => (props.newUserbought ? ' 12px 0' : '12px')};
  }

  & .anchor {
    display: block;
    position: relative;
    visibility: hidden;
    top: -90px;
  }

  & .Collapsible {
    margin: 8px 0 10px;
    border-bottom: 1px solid #ccc;
    padding: 4px 0 12px;

    &:nth-child(1) {
      border-top: 1px solid #ccc;
      margin-top: 16px;
    }
  }
`;
export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 20px;
    margin: 10px;
  }

  img {
    width: 60px;
    height: 60px;
    @media (max-width: 768px) {
      width: 50px;
      height: 50px;
    }
  }
`;

export const Seperator = styled.div`
  background: #fff;
  padding: ${(props) =>
    props.padding ? props.padding : props.reviews ? '28px 12px 0' : '0'};
  @media (min-width: 768px) {
    padding: ${(props) =>
      props.padding ? props.padding : props.reviews ? '28px 0 0' : '0'};
  }

  .userReviewsOuter {
    margin-top: ${(props) => (props.showNewReviewView ? '18px' : '')};
  }
`;
export const ReviewHeader = styled.div`
  padding: 0 0 16px;
  background: #fff;
  margin-top: 30px;

  @media (max-width: 720px) {
    padding: 0 14px 16px;
    margin-top: 0;

    .horizontalLine {
      width: 74px;
      height: 1px;
      margin-top: 12px;
      margin-bottom: 10px;
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
`;
export const GreenTitle = styled.h3`
  font-size: 16px;
  color: #63b0a8;
  font-weight: 700;
  padding: ${(props) => (props.testimonial ? '0' : '12px 0 8px')};

  & svg {
    position: absolute;
    margin-left: 4px;
  }
`;

export const PdpTestimonialContainer = styled.div`
  padding-bottom: 20px;
`;

export const UserDetailContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const BlackReviewTitle = styled.h2`
  padding: 10px 0 16px;
  // text-align: center;
  font-size: clamp(20px, 3vw, 24px);
  color: rgb(0 0 0 / 80%);
  letter-spacing: 2px;
  font-weight: 600;
  ${(props) =>
    props.seperate
      ? css`
          margin: 20px 14px 0;
          border-bottom: 1px solid #00000018;
        `
      : null};
  @media (max-width: 720px) {
    padding: ${(props) => (props.showNewReviewView ? '10px 0 10px' : '')};
  }
`;

export const VerifiedBuyersTitle = styled.h2`
  color: #87ab66;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
`;

export const TotalReview = styled.p`
  font-size: 13px;
  color: rgb(0 0 0 / 68%);
  padding: 4px 0 0 4px;
`;

export const UserLocation = styled.p`
  font-size: clamp(10px, 2vw, 12px);
  color: ${(props) => (props.imageReview ? '#6e6e6e' : 'rgb(0 0 0 / 38%)')};
  font-weight: 400;
  margin-bottom: 10px;
  padding-right: 2px;
`;

export const Review = styled.div`
  font-size: 14px;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 6px 0;

  & p {
    padding-right: 6px;
  }

  & img {
    width: 62px !important;
    height: 62px !important;
    border-radius: 6px;
    margin: 10px 10px 0 auto;
  }

  & br {
    display: none;
  }
`;

export const OneImageBox = styled.div`
  width: 156px;
  height: 156px;

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    cursor: pointer;
  }
`;

export const TwoImageBox = styled.div`
  position: relative;
  width: 76px;
  height: 76px;
  margin: 0 3px 4px;
  cursor: pointer;

  & :nth-child(2) {
    margin-bottom: 0;
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }
`;

export const Subtitle = styled.h3`
  font-size: ${(props) =>
    props.bigTitle ? 'clamp(18px,2vw,22px)' : 'clamp(18px, 2vw, 20px)'};
  color: #000;
  letter-spacing: 1px;
  font-weight: 600;
  padding: ${(props) =>
    props.testimonial
      ? '7px 0 7px'
      : props.showHeadingWithLogo
        ? '0px'
        : '0 0 20px'};
  justify-content: ${(props) => (props.sortValue ? 'space-between' : 'unset')};
  @media (max-width: 720px) {
    padding: ${(props) =>
      props.testimonial
        ? '7px 0 7px'
        : props.showHeadingWithLogo
          ? '0px'
          : props.allReview
            ? '0 0 10px'
            : '0 0 20px 10px'};
  }

  span {
    opacity: 0.54;
    font-size: 16px;
    font-weight: 500;
    margin-left: 6px;
    text-align: center;
    color: #000;
  }

  display: flex;
  align-items: center;
`;
export const SubtitleVideo = styled.h3`
  font-size: ${(props) =>
    props.allReviews ? 'clamp(16px, 2vw, 18px)' : 'clamp(14px, 2vw, 16px)'};
  color: ${(props) => (props.allReviews ? '#000' : 'hsl(0deg 0% 0% / 78%)')};
  padding: ${(props) => (props.ratingHeading ? '0 0 10px 0' : '0 0 20px 0px')};
  letter-spacing: 1px;
  font-weight: 600;
  @media (max-width: 720px) {
    padding-left: 10px;
    display: ${(props) => (props.ratingHeading ? 'none' : 'block')};
  }
`;

export const Button = styled.div`
  display: inline-block;
  background: ${(props) => (props.white ? '#fff' : '#ef4e5e')};
  color: ${(props) => (props.white ? '#ef4e5e' : '#fff')};
  border-radius: 6px;
  outline: none;
  border: none;
  font-weight: 600;
  box-shadow: 0 1px 2px 0 #00000029;
  text-align: center;
  padding: ${(props) => props.padding};
  font-size: ${(props) => props.font};
  cursor: pointer;
`;

export const MotherStatus = styled.p`
  font-size: clamp(12px, 2vw, 14px);
  color: #6e6e6e;
  font-weight: normal;
  letter-spacing: 0.2px;
`;
export const UserName = styled.h6`
  font-size: clamp(13px, 2vw, 15px);
  font-weight: 500;
  color: hsla(0deg, 0%, 0%, 78%);
  text-transform: capitalize;
  margin-bottom: 8px;

  @media (max-width: 720px) {
    &.ellipsis {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100px;
    }
  }
`;

export const Verified = styled.div`
  font-size: ${(props) => (props.newSection ? '6px' : '8px')};
  border-radius: 12px;
  padding: 3px 4px;
  color: #63b0a9;
  display: flex;
  align-items: center;
  font-weight: 500;
  max-height: ${(props) => (props.newSection ? '12px' : '18px')};
  margin-left: ${(props) => (props.newSection ? '4px' : 'auto')};
  border: 1px solid;

  .buyer {
    padding-left: 5px;
  }

  .verifiedBuyer {
    margin-left: 4px;
  }
`;

export const VerifiedIcon = styled.span`
  position: relative;
  top: 1px;
`;

export const ReviewImageContainer = styled.div`
  width: 30%;
  text-align: end;
`;

export const MoreImagesText = styled.div`
  position: absolute;
  top: 23px;
  text-align: center;
  color: white;
`;
export const ViewComments = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  color: hsl(0deg 0% 0% / 58%);
  font-weight: 500;
`;
export const Helpful = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 68%);
  padding: ${(props) =>
    props.showNewReviewView
      ? '2px 0 0 0'
      : props.popupHelpful
        ? '10px 0 0'
        : '12px 0'};
  margin-top: ${(props) =>
    props.popupHelpful && !props.showNewReviewView ? '10px' : '0'};
  border-bottom: ${(props) =>
    props.popupHelpful || props.showNewReviewView
      ? 'none'
      : props.fromReviews
        ? '1px solid rgba(231, 231, 231, 0.29)'
        : '1px solid #e0e0e0'};
  border-top: ${(props) =>
    props.popupHelpful && !props.showNewReviewView
      ? '1px solid #e0e0e0'
      : 'none'};
  font-size: 14px;
  margin-bottom: ${(props) => (props.showNewReviewView ? '0' : '10px')};

  & .helpful {
    flex-grow: 1;
  }

  & .yes {
    margin-right: 50px;
    cursor: pointer;
  }

  .help {
    font-size: ${(props) =>
      props.fromReviews ? '12px' : 'clamp(13px, 2vw, 16px)'};
    color: ${(props) =>
      props.fromReviews ? 'rgba(0, 0, 0, 0.4);' : 'rgba(0, 0, 0, 0.55)'};
    font-weight: normal;
    margin-right: 10px;
  }

  .helpfulText {
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
    font-weight: normal;
  }
`;

export const Feedback = styled.div`
  padding: 8px 0 14px;
  font-weight: 500;
  color: rgb(0 0 0 / 83%);
  border-bottom: 1px solid #e0e0e0;
  font-size: 14px;
`;

export const TotalLikes = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  position: relative;
  gap: ${(props) => (props.fromReviews ? '1px' : '4px')};
  font-size: ${(props) =>
    props.fromReviews
      ? '11px'
      : props.popupHelpful
        ? '12px'
        : 'clamp(14px, 2vw, 16px)'};
  color: ${(props) =>
    props.fromReviews && props.selected
      ? '#ef4e5e'
      : props.fromReviews
        ? 'rgba(0, 0, 0, 0.4)'
        : 'rgba(0, 0, 0, 0.55)'};
  @media (min-width: 720px) {
    cursor: pointer;
  }

  img {
    width: 14px;
    height: 14px;
    margin-left: 6px;
    @media (min-width: 768px) {
      width: 16px;
      height: 16px;
    }
  }

  .lowOpacity {
    opacity: 0.4;
  }

  button {
    border: none;
    background: white;
    display: flex;
    justify-content: center;
    padding: 0;
  }
`;

export const MyloMember = styled.div`
  font-size: clamp(11px, 2vw, 14px);
  margin-bottom: 8px;
  border-left: 1px solid rgb(0 0 0 / 20%);
  margin-left: 10px;
  font-weight: 500;
  color: rgb(0 0 0 / 38%);
  padding-left: 6px;
`;

export const ScrollUserImageStyle = styled.div`
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;
  position: relative;
  object-fit: cover;
  flex-basis: 40%;
  flex-shrink: 0;
  width: 100%;
  height: unset;
  cursor: pointer;
  @media (max-width: 720px) {
    cursor: default !important;
    flex-basis: 70%;
  }

  img {
    object-fit: fill;
    border-radius: 4px;
  }

  &:hover {
    transform: scale(1.02);
  }

  & .lowOpacity {
    opacity: 0.4;
  }

  span {
    position: unset !important;
    padding-top: 100% !important;
  }

  &.babyTrustImageContainer {
    span {
      padding-top: 150% !important;
    }
  }

  .bottomGradient {
    height: 26px;
    position: absolute;
    bottom: 0;
    z-index: 9;
    width: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.6)
    );
    border-radius: 4px;
  }
`;

export const ReviewChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  text-align: center;
  gap: 10px;

  span {
    border-radius: 6px;
    background-color: #d3e6e4;
    color: rgb(78 78 78 / 80%);
    font-size: 14px;
    font-weight: 500;
    height: 34px;
    line-height: 34px;
    min-width: 80px;
    padding: 0 14px;
  }
`;

export const LocalSimilarSection = styled.div`
  max-width: 100%;
  background: none;
  padding-top: 0px;

  @media (min-width: 720px) {
    margin: ${(props) =>
      props.withCategories ? '0px 7% 0 20%' : '0px 7% 0 7%'};
    padding-top: 30px;
    background: #fff;
  }
`;

export const ImageThumbnailContainer = styled.div`
  flex-basis: 18%;
  flex-shrink: 0;
  margin-right: 16px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border-radius: 4px;
  transition:
    transform 0.3s cubic-bezier(0.155, 1.105, 0.295, 1.12) 0s,
    box-shadow 0.3s ease 0s;
  @media (max-width: 720px) {
    flex-basis: 28%;
    margin-right: 0;
    padding: 0 6px;
    cursor: default;
  }

  & .lowOpacity {
    opacity: 0.4;
  }

  &.babyTrustImages {
    flex-basis: 47%;
    @media (min-width: 768px) {
      flex-basis: 32%;
    }
  }
`;

export const TextReviewsContainer = styled.div`
  padding-top: 12px;

  .reviewTitle {
    font-size: clamp(14px, 2vw, 16px);
    opacity: 0.87;
    margin-top: 10px;
    font-weight: 600;
  }
`;
export const UserInfoTop = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 16px;

  .username {
    color: #919191;
    font-size: 12px;
    font-weight: 600;
  }

  .boughtWhen {
    color: #919191;
    font-size: 12px;
    font-weight: 400;
    padding-top: 4px;
  }

  .partition {
    height: 30px;
    width: 1px;
    border-left: 1px solid #939393;
  }

  .verifiedText {
    font-size: 12px;
    color: #62b0a9;
    font-weight: 600;
  }

  .verified {
    width: 13px;
    height: 13px;
  }
`;
export const VerifiedImg = styled.img`
  width: 20%;
  @media (min-width: 768px) {
    width: ${(props) => (props.clothDiaper ? '6%' : '8%')};
    margin-left: 10px;
  }
`;

export const FlexImagesContainer = styled.div`
  display: flex;
  padding: 10px 0px;
  align-items: center;
  overflow-x: ${(props) => (props.showNewReviewView ? 'auto' : '')};

  img {
    width: 85px;
    margin-right: 10px;
    border-radius: 8px;
    @media (min-width: 768px) {
      width: 102px;
      margin-right: 20px;
      cursor: pointer;
    }

    height: ${(props) => (props.showNewReviewView ? '85px' : '')};
    &.lowOpacity {
      opacity: 0.4;
    }
    flex-shrink: ${(props) => (props.showNewReviewView ? '0' : 'unset')};
    object-fit: ${(props) => (props.showNewReviewView ? 'cover' : '')};
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ParitionSpan = styled.span`
  border-top: 1px solid #d5d5d5;
  margin: 20px 0 0;
  display: block;
  width: 100%;
`;

export const BreadCrumbSection = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 16px;
  font-size: clamp(13px, 2vw, 15px);
  text-transform: uppercase;

  img {
    width: 13px;
    rotate: -90deg;
    margin: 0 4px;
    opacity: 0.6;
  }

  .lastcrumb {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .blue {
    color: #63b0a8;
    font-weight: bold;
  }

  .light {
    color: rgba(0, 0, 0, 0.4);
    font-weight: 400;
  }

  @media (min-width: 768px) {
    padding: 30px 0;
    width: ${(props) => (props.newUI ? '79%' : '100%')};
    margin: auto;
  }
`;

export const SortContainer = styled.div`
  position: relative;

  .sortType {
    display: flex;
    align-items: center;
    font-size: clamp(12px, 2vw, 16px);
    color: #ef4e5e;
    font-weight: bold;

    img {
      width: 10px;
      rotate: 90deg;
      margin-left: 6px;
    }

    @media {
      cursor: pointer;
    }
  }

  .sortPopover {
    padding: 16px 16px 10px;
    box-shadow: 0px 2px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    position: absolute;
    display: ${(props) => (props.showPopup ? 'block' : 'none')};
    font-size: 12px;
    width: 180px;
    right: 0px;
    top: 20px;
    @media (min-width: 720px) {
      top: 30px;
    }
    z-index: 10;

    .sortHeading {
      font-size: 12px;
      font-weight: normal;
      color: #bdc2c3;
    }

    .sortOption {
      margin: 12px 0;
      font-size: 12px;
      font-weight: 500;
      @media (min-width: 768px) {
        cursor: pointer;
      }
    }

    .selectedOption {
      color: #ef4e5e;
      font-weight: 600;
    }

    transition:;
  }
`;

export const ReviewSkeleton = styled.div`
  .gradient_load {
    will-change: transform;
    animation: placeHolderShimmer 1s linear infinite forwards;
    backface-visibility: hidden;
    background: #e6e6e6;
    background: linear-gradient(90deg, #eee 8%, #ddd 18%, #eee 33%);
    background-size: 900px 104px;
    height: 100%;
    position: relative;
    border-radius: 10px;
  }

  @keyframes placeHolderShimmer {
    0% {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      background-position: -468px 0;
    }
    to {
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
      background-position: 468px 0;
    }
  }
`;

export const ReviewsContainerFlex = styled.div`
  display: flex;
  justify-content: space-between;
  position: relative;
  @media (max-width: 768px) {
    display: block;
    position: unset;
  }
`;
export const ReviewLeftContainer = styled.div`
  .productImgContainer {
    position: relative;
    padding-top: 100%;
    width: 100%;
    margin-bottom: 20px;

    span {
      position: unset !important;
    }

    img {
      object-fit: fill !important;
    }
  }

  flex-basis: 35%;
  @media (max-width: 768px) {
    display: none;
  }
`;
export const ReviewRightContainer = styled.div`
  flex-basis: 100%;

  @media (min-width: 768px) {
    flex-basis: 60%;
    overflow-x: auto;
  }
`;
export const SizeTag = styled.div`
  padding: 6px 8px;
  background: #f4f4f4;
  width: max-content;
  font-size: 12px;
  border-radius: 2px;
  font-weight: 500;
  margin: 10px 0;
`;

export const BabyTrustImagesSection = styled.div`
  padding: 20px 20px 0;
  @media (max-width: 768px) {
    padding: 20px 0px 0;
  }

  .heading {
    font-size: clamp(16px, 2vw, 18px);
    color: #000;
    font-weight: 600;
    text-transform: ${(props) =>
      props.isFertilityProduct ? 'normal' : 'uppercase'};
    padding: 10px 16px;
    @media (min-width: 768px) {
      padding: 16px 0;
    }
  }
`;

export const SubFeatures = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .featureItem {
    color: #4c4c4c;
    background-color: #cff1ff;
    border-radius: 45px;
    font-size: 14px;
    padding: 6px 14px;
    font-weight: 500;
  }
`;

export const AiSummaryReview = styled.div`
  margin: 18px 0px 0px 0px;
  padding: 5px 12px 12px 12px;
  border-radius: 8px;
  background-color: #f6f6f6;
  .headingWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .heading {
    font-size: 14px;
    font-weight: 600;
    color: #565656;
    font-style: italic;
  }
  .subHeading {
    font-size: 12px;
    font-weight: normal;
    color: #565656;
    font-style: italic;
  }
  .content {
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
    line-height: 1.29;
  }
  .horizontalLine {
    width: 153px;
    height: 1px;
    background-color: #cbcbcb;
    margin: 0 0 10px 0;
  }
`;

export const TextReviewsContainerNew = styled.div`
  display: flex;
  gap: 10px;

  .userImage {
    border-radius: 50%;
    object-fit: cover;
  }

  .username {
    font-size: 12px;
    font-weight: 500;
    color: #434343;
  }

  .boughtWhen {
    font-size: 12px;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.4);
    flex-basis: 70%;
  }

  .userBought {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .userDetails {
    width: 100%;
  }

  .location {
    font-size: 12px;
    font-weight: 400;
    color: #434343;
    font-style: italic;
  }

  .dot {
    background-color: #434343;
    width: 4px;
    height: 4px;
    border-radius: 50%;
  }
`;
